// extracted by mini-css-extract-plugin
export default {"value":"ProvisionTypeSelectOption-module__value--3nH+Q","badgeWrapper":"ProvisionTypeSelectOption-module__badgeWrapper--3UjVl"};